import { t } from "@lingui/macro";

/**
 * Skip Navigation Links Component
 * Provides keyboard users with a way to skip repetitive navigation
 * and jump directly to main content.
 *
 * This component is visually hidden until focused, following WCAG guidelines.
 */
export const SkipNavigation = () => {
  return (
    <a
      href="#main-content"
      className="sr-only z-[9999] bg-primary px-4 py-2 text-primary-foreground focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:rounded-md focus:shadow-lg"
    >
      {t`Skip to main content`}
    </a>
  );
};
